import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Layout from './components/Layout';
import StartPage from './pages/StartPage';
import BehaelterPage from './pages/BehaelterPage';
import BehaelterDetailPage from './pages/BehaelterDetailPage';
import SuchePage from './pages/SuchePage';
import InventarPage from './pages/InventarPage';
import EinstellungenPage from './pages/EinstellungenPage';
import QrRedirectPage from './pages/QrRedirectPage';
import EtikettPage from './pages/EtikettPage';

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const login = t => { localStorage.setItem('token', t); setToken(t); };
  const logout = () => { localStorage.removeItem('token'); setToken(null); };

  useEffect(() => {
    const handler = () => setToken(null);
    window.addEventListener('lager:logout', handler);
    return () => window.removeEventListener('lager:logout', handler);
  }, []);

  if (!token) return <LoginPage onLogin={login} />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/q/:token" element={<QrRedirectPage />} />
        <Route path="/behaelter/:id/etikett" element={<EtikettPage />} />
        <Route path="*" element={
          <Layout onLogout={logout}>
            <Routes>
              <Route path="/" element={<StartPage />} />
              <Route path="/behaelter" element={<BehaelterPage />} />
              <Route path="/behaelter/:id" element={<BehaelterDetailPage />} />
              <Route path="/suche" element={<SuchePage />} />
              <Route path="/inventar" element={<InventarPage />} />
              <Route path="/einstellungen" element={<EinstellungenPage />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </BrowserRouter>
  );
}
